var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-mode-switch d-flex align-items-center justify-content-between",on:{"click":_vm.toggleValue}},[_vm._v(" "+_vm._s(_vm.$t('activities.editMode'))+" "),_c('div',{staticClass:"switch ml-2",class:{'on': _vm.internalValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }